<template>
    <div class="d-inline pr-2 pl-2">
        <!-- NOTE - Button -->
        <b-button variant="light-primary" class="mb-2 w-100" @click="openModal">
            <i class="fas fa-sort mb-1"></i>
            Re-order Hashtag Set Groups</b-button
        >

        <!-- NOTE - Manage Groups Modal -->
        <b-modal
            size="lg"
            ref="manage-order-modal"
            id="manage-order-modal"
            centered
            title="Re-order your Hashtag Set Groups"
        >
            <!-- Modal preloader -->
            <PagePreloader v-if="modalisloading"></PagePreloader>

            <!-- Error management -->
            <CustomAlerts :errors="errors"></CustomAlerts>

            <!-- Info -->
            <InfoBox
                text="You can re-order your Hashtag Set Groups by simply dragging and dropping them to the order you would like!"
            ></InfoBox>

            <!-- NOTE - Start draggable -->
            <draggable
                v-model="groups"
                group="manageModalGroup"
                class="alert row shadow-sm mx-1 gutter-b minh50"
            >
                <template v-for="group in groups">
                    <span
                        class="btn btn-font-sm font-weight-bold m-1 btn-light-primary col-6 text-left mb-2"
                    >
                        <template v-if="group.emoji">
                            {{ group.emoji }}
                        </template>
                        {{ group.title }}
                    </span>
                </template>
            </draggable>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    type="Submit"
                    variant="success"
                    :class="
                        modalisloading ? 'spinner spinner-darker-success spinner-left mr-3' : ''
                    "
                    @click="updateOrder"
                    :disabled="modalisloading"
                >
                    Save changes
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>
    </div>
</template>
<style scoped>
.minh50 {
    min-height: 50px;
}
</style>
<script>
// Defaults
import axios from "axios";
// Draggable
import draggable from "vuedraggable";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import InfoBox from "@/view/content/Custom/InfoBox.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "buttonManageHashtagGroupsOrder",
    mixins: [axiosErrorManagement],
    components: {
        CustomAlerts,
        PagePreloader,
        draggable,
        InfoBox,
    },
    props: {
        propGroups: Array,
    },
    data() {
        return {
            // Errors
            errors: [],

            // Displayers
            modalisready: false,

            // Data
            groups: [],

            // Preloaders
            modalisloading: false,
        };
    },
    methods: {
        // Generate array
        generateGroupArray() {
            // Empty base array
            this.groups = [];

            // Loop through mygroups
            this.propGroups.forEach((currentItem) => {
                this.groups.push({
                    id: currentItem.id,
                    title: currentItem.title,
                    emoji: currentItem.emoji,
                });
            });
        },

        // Open modal
        openModal() {
            // Refresh errors
            this.errors = [];

            // Generate
            this.generateGroupArray();

            // Open modal
            this.$refs["manage-order-modal"].show();
        },

        /**
         * SECTION - Update all the hashtag groups
         */
        updateOrder() {
            // Reset errors
            this.errors = [];

            // Set loader
            this.modalisloading = true;

            // Perform post
            axios
                .post("myhashtagsv2/groups/update/order", {
                    groups: this.groups,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle
                    if (data.status == "OK") {
                        // Emit if successful
                        this.refreshHashtags();

                        // Close modal
                        this.$refs["manage-order-modal"].hide();
                    }

                    // Handle error messages
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        },

        refreshHashtags() {
            this.$emit("groupManageSuccess");
        },
    },
};
</script>
